import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { AppHeaderComponent } from './app-header/app-header.component';
import { AboutModalComponent } from './about-modal/about-modal.component';
import { RouterModule } from '@angular/router';
import { SettingMenuComponent } from './setting-menu/setting-menu.component';
import { AppSkeltonComponent } from './app-skelton/app-skelton.component';
import { PatientModalComponent } from './patient-update-modal/patient-modal.component';
import { HospitalListComponent } from './hospital-list/hospital-list.component';
import { ItemListComponent } from './item-list/item-list.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    ReactiveFormsModule,
  ],
  declarations: [AppHeaderComponent, SettingMenuComponent, AppSkeltonComponent, PatientModalComponent, HospitalListComponent, AboutModalComponent,
    ItemListComponent],
  exports: [AppHeaderComponent, AppSkeltonComponent]
})
export class SharedModule { }
